require.register("base-extension", function(exports, require, module){
  var BaseExtension = {};

module.exports = BaseExtension;

  
});

